export default {
  isOpen: state => state.isOpen,
  openingHours: state => state.openingHours,
  tenantDetails: state => state.tenantDetails
}



// WEBPACK FOOTER //
// ./src/store/modules/openinghours/getters.js